<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>
<script>
import {
  getList,
	save
} from "@/api/order/aterialIntercept";
import cTable from "@/base/common/index";
import { getSelectType } from "@/api/public";
// import { getAllClient, getCompanies } from "@/api/user/client";
// import { getCurrency } from "@/api/finance/currency";
// import { getAgent } from "@/api/tracker/agent";
import { getAllClient } from "@/api/user/client";
import { getUser } from "@/api/user/internal";
// import { getChargingType } from "@/api/double/list";
// import { getConfig,getSubjectCost } from "@/api/tracker/cost_page";
export default {
  name: "aterialIntercept",
	components:{
		cTable
	},
  async created() {
		
		// this.status = (await getSelectType('INTERCEPT_STATUS')).data.payload['INTERCEPT_STATUS']
		// this.statusObj = this.status.reduce((a,b)=>{
		// 	a[b.value] = b.label
		// 	return a
		// },{})
		// let agentList = (await getAgent()).data.payload.rows
		
		// this.header.searchs.forEach(async item=>{
			// if(item.key === 'status')item.options = this.status
			// if (item.key === "client_id")
			//   item.options = (await getAllClient()).data.payload.rows;
			// if (item.key === "customer_service_id")
			// 	item.options = (
			// 		await getUser({ standard: "CustomerService" })
			// 	).data.payload.rows;
		// })
		// this.modals.add.fields.forEach(t=>{
		// 	if(t.key === 'cod_agent')t.options = agentList
		// })
  },
  methods: {},
  data() {
    let that = this;
    return {
			status:[],
			statusObj:[],
			agentList:[],
			configs:{},
			client:[],
			companies:[],
			unit:[],
			bubble:[],
			currencyList:[],
			SubjectCost:[],
      methods: {
				getSelectType,
        list(params){
					return getList(params)
				},
				save
      },
      modals: {
        add: {
					type:'add',
          methods: {
            ok({ row, close }) {
							let data = JSON.parse(JSON.stringify(row))
              this.$page.handleRequestMethods('save', data, true).then((e) => {
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              styles: {
                top: "30px",
              },
              width: 700,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
							remarks: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "blur",
							  },
							],
							airway_number: [
							  {
							    required: true,
							    message: "cannot be empty",
							    trigger: "blur",
							  },
							],
            },
          },
          grid: [
            {airway_number:24},
            {remarks:24},
          ],
          fields: [
						{
						  name: this.$t("order_number"),
						  key: "airway_number",
						  component: "Input",
						  placeholder: () => this.$t("enter") + this.$t("order_number"),
						  bind: {
						    type: "textarea",
						    rows: 8
						  }
						},
						{
						  name: this.$t("Remarks"),
						  key: "remarks",
						  component: "Input",
						  placeholder: () => this.$t("enter") + this.$t("Remarks"),
						  bind: {
						    type: "textarea",
						    rows: 3
						  }
						},
          ],
        },
      },
      header: {
        searchs: [
					{
					  key: "startTime",
					  component: "DatePicker",
					  placeholder() {
					    return (
					      this.$t("select") +
					      this.$t("start") +
					      this.$t("date") +
					      this.$t("time")
					    );
					  },
					  bind: {
					    type: "date",
					    options: {
					      disabledDate(time) {
					        return time.getTime() > Date.now();
					      }
					    },
					    style: {
					      width: "175px"
					    }
					  },
					  methods: {
					    format({ searchForm, value, newFormData }) {
					      return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
					    }
					  }
					},
					{
					  key: "endTime",
					  component: "DatePicker",
					  placeholder() {
					    return (
					      this.$t("select") +
					      this.$t("end") +
					      this.$t("date") +
					      this.$t("time")
					    );
					  },
					  bind: {
					    type: "date",
					    options: {
					      disabledDate(time) {
					        return time.getTime() > Date.now();
					      }
					    },
					    style: {
					      width: "175px"
					    }
					  },
					  methods: {
					    format({ searchForm, value, newFormData }) {
					      return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
					    }
					  }
					},
          {
            key: "keywords",
            placeholder() {
              return this.$t("order_number");
            },
            bind: {
              type: "textarea",
              rows: 2,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("launch"),
              fnName: "launch",
              type: "launch",
							id:1584,
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
          	launch(){
          		this.getModal('add').open({},function(){
          			this.setTitle(this.$t("Update Status"));
          		})
          	},
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
        },
				{
				  name: this.$t("order_number"),
				  key: "airway_number",
				  minWidth: 120,
					header:{
						copy:true
					}
				},
				{
				  name: this.$t("country_t"),
				  key: "country",
				  minWidth: 120,
				},
				{
				  name: this.$t("InterceptRemarks"),
				  key: "remarks",
				  minWidth: 120,
				},
				{
				  name: this.$t("exlType"),
				  key: "status",
				  minWidth: 120,
				},
				{
				  name: this.$t("operate"),
				  key: "create_name",
				  minWidth: 120,
				},
				{
				  name: this.$t("operation time"),
				  key: "create_time",
				  minWidth: 120,
				},
       /* {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success",
              },
							// id:1258
            },
          ],
          methods: {
          },
        }, */
      ],
    };
  },
};
</script>
<style lang="scss" scoped></style>
